import React from "react";
import { Link } from "react-router-dom";
import tw from "twin.macro";

const Container = tw.div`max-w-screen-xl mx-auto px-4 sm:px-8 py-8 border-t border-gray-200`;
const Title = tw.p`text-sm font-bold text-gray-500 uppercase tracking-wide mb-3 text-center`;
const Links = tw.div`flex flex-wrap justify-center gap-4 sm:gap-6`;
const StyledLink = tw(Link)`text-sm font-semibold text-primary-500 hover:text-primary-700 transition duration-300`;

export default ({ productName, links = [] }) => {
  if (!links.length) return null;

  return (
    <Container>
      <Title>{productName} — Legal</Title>
      <Links>
        {links.map((link) => (
          <StyledLink key={link.href} to={link.href}>
            {link.label}
          </StyledLink>
        ))}
      </Links>
    </Container>
  );
};
